import moment from 'moment-jalaali'

import { lang } from '../../localization'

const convertDate = (date: string | undefined) => {
  if (date) {
    const m = moment(date)
    if (lang === 'fa') {
      return {
        year: m.format('jYYYY'),
        month: m.format('jMMMM'),
        day: m.format('jDD')
      }
    } else {
      return {
        year: m.format('YYYY'),
        month: m.format('MMMM'),
        day: m.format('DD')
      }
    }
  }
  return {
    year: '',
    month: '',
    day: ''
  }
}
export default convertDate
